import { DEFAULT_PAGINATION_PAGE } from '@/common/constants/page';

import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state: {
    countriesAgreements: [],
    countriesGroupAgreements: [],
    paramsRequestLists: {
      pageNumber: 1,
      pageSize: 0,
      isActive: true,
    },
    agreementsPage: { ...DEFAULT_PAGINATION_PAGE },
  },
};
